import React from 'react';

import { RunIdentificationPair } from '@neptune/shared/entity-domain';

import { Attribute } from 'domain/experiment/attribute';

type ExperimentsModeContextValue = {
  experimentsOnlyEnabled: boolean;
  setExperimentsOnlyEnabled: (value: boolean) => void;
  getEntityIdentificationPair: (entity: {
    attributes: Attribute[];
  }) => RunIdentificationPair | undefined;
  getEntityIdentificationKeyFromAttributes: (attributes: Attribute[]) => string | undefined;
};

export const ExperimentsModeContext = React.createContext<ExperimentsModeContextValue>({
  get experimentsOnlyEnabled(): boolean {
    throw new Error('ExperimentsModeContext is not initialized.');
  },
  setExperimentsOnlyEnabled: () => {
    throw new Error('ExperimentsModeContext is not initialized.');
  },
  getEntityIdentificationPair() {
    throw new Error('ExperimentsModeContext is not initialized.');
  },
  getEntityIdentificationKeyFromAttributes() {
    throw new Error('ExperimentsModeContext is not initialized.');
  },
});
